import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

class CustomizedTextField extends Component {

    handleKeyDown(event) {
        if ((!this.props.multiline && event.keyCode === 13 /*enter*/) || event.keyCode === 27 /*esc*/) {
            event.target.blur();
        }
    }

    render() {
        return (
            <TextField onKeyDown={this.props.handleKeyDown ? this.props.handleKeyDown : this.handleKeyDown.bind(this)} {...this.props} />
        )
    }
}

export default (CustomizedTextField);
